import React from "react"
import {
    FacebookShareButton,
    LinkedinShareButton,
    TelegramShareButton,
    TwitterShareButton,
    WhatsappShareButton
} from "react-share"
import { useLocation } from "@reach/router"

function SocialBlock() {
    const { href } = useLocation()
    return (
        <div className="social-icon grid grid-cols-1 sm:my-4 sm:border-y sm:border-[#D9D9D9] sm:py-10 ">
            <div className="hidden sm:flex sm:flex-row sm:items-baseline sm:justify-center sm:py-10">
                <LinkedinShareButton url={href}>
                    <i className="fa-brands fa-linkedin px-2"></i>
                </LinkedinShareButton>
                <FacebookShareButton url={href}>
                    <i className="fa-brands fa-facebook-square px-2"></i>
                </FacebookShareButton>
                <TwitterShareButton url={href}>
                    <i className="fa-brands fa-twitter px-2"></i>
                </TwitterShareButton>
                <WhatsappShareButton url={href}>
                    <i className="fa-brands fa-whatsapp-square px-2"></i>
                </WhatsappShareButton>
                <TelegramShareButton url={href}>
                    <i className="fa-brands fa-telegram px-2"></i>
                </TelegramShareButton>
            </div>
        </div>
    )
}

export default SocialBlock
